module.exports = __webpack_public_path__ + "assets/24a3ff38afde257888d755ece9bfd704.js";